import React, { useState, useRef } from "react";
import { Container, Row, Col, Button, Form } from "react-bootstrap";
import "../../../App.css";
import "../../../css/bootstrap.scss";
import user_icon from "../../../images/reg_user.png";
import red_cross_icon from "../../../images/circle_cross.png";
import identity_card_banner from "../../../images/identity_card_banner.png";
import QRCode from "react-qr-code";
import BackButton from "../../Includes/BackButton";
import CameraModal from "../../Camera/CameraModal";
import SelfieCameraModal from "../../Camera/SelfieCameraModal";
import { reduxForm, InjectedFormProps } from "redux-form";
import { connect } from "react-redux";
import {
  setotherIdentityFrontendPic,
  setotherIdentityBackendPic,
  setwizardPageNumber,
} from "../../authslice";
import { RootState } from "../../store";
import { useDispatch, useSelector } from "react-redux";
import { ToastBox } from "MyComponents/Toaster";
import Spacer from "MyComponents/UI/Spacer";
import { updatePersonalKycDraftStep } from "Utils/personalKycDraft";
import { useTranslation } from "react-i18next";

interface Props {}

const UploadOtherDocument: React.FC<
  Props & InjectedFormProps<{}, Props, FormData>
> = (props) => {
  const { t } = useTranslation();
  const { handleSubmit } = props;
  const dispatch = useDispatch();
  const BaseURL = process.env.REACT_APP_BASE_URL;
  const page = useSelector((state: RootState) => state.auth.wizardPageNumber);
  const theme = useSelector((state: RootState) => state.theme.theme);
  const [showModal1, setShowModal1] = useState(false);
  const [showModal2, setShowModal2] = useState(false);
  const modalRef1 = useRef<any | null>(null);
  const modalRef2 = useRef<any | null>(null);
  const userId = useSelector((state: RootState) => state.auth.userID);
  const kycToken = useSelector((state: RootState) => state.auth.kycToken);

  const otherIdentityFrontendPic = useSelector((state: RootState) => state.auth.otherIdentityFrontendPic);
  const otherIdentityBackendPic = useSelector((state: RootState) => state.auth.otherIdentityBackendPic);

  const [srcModal1, setSrcModal1] = useState<string | null>(
    otherIdentityFrontendPic && otherIdentityFrontendPic.startsWith("data:image") ? otherIdentityFrontendPic : null
  );
  const [srcModal2, setSrcModal2] = useState<string | null>(
    otherIdentityBackendPic && otherIdentityBackendPic.startsWith("data:image") ? otherIdentityBackendPic : null
  );
  const [validated, setValidated] = useState(false);

  const updateSrcModal1 = (newState: string) => {
    dispatch(setotherIdentityFrontendPic(newState));
    setSrcModal1(newState);
    setValidated(false);
  };

  const updateSrcModal2 = (newState: string) => {
    dispatch(setotherIdentityBackendPic(newState));
    setSrcModal2(newState);
  };

  const handleModal1CrossIconClick = () => {
    setSrcModal1(null);
    dispatch(setotherIdentityFrontendPic(""));
  };

  const handleModal2CrossIconClick = () => {
    setSrcModal2(null);
  };

  const submitForm = () => {
    if (!srcModal1) {
      setValidated(true);
      return;
    }
    dispatch(setwizardPageNumber(page + 1));
    localStorage.setItem('pageNumber', `${page + 1}`);
  };

  const saveExit = () => {
    if (!srcModal1) {
      setValidated(true);
      return;
    }
    dispatch(setwizardPageNumber(page + 1));
    localStorage.setItem('pageNumber', `${page + 1}`);

    if (userId) {
      updatePersonalKycDraftStep(userId, 'idVerification', {
        otherIdentityFrontendPic: srcModal1,
        otherIdentityBackendPic: srcModal2
      });
      updatePersonalKycDraftStep(userId, 'wizardState', { pageNumber: page + 1 });
    }
  };

  return (
    <>
      <ToastBox />
      <CameraModal
        show={showModal1}
        handleClose={() => setShowModal1(false)}
        title="Other Identification"
        ref={modalRef1}
        side="Front side of"
        updateSrc={updateSrcModal1}
      />
      <SelfieCameraModal
        show={showModal2}
        handleClose={() => setShowModal2(false)}
        title="Other Identification"
        ref={modalRef2}
        side="Back side of"
        updateSrc={updateSrcModal2}
      />

      <Container fluid>
        <Row>
          <Col md={12}>
            <div className="mt-5">
              <Spacer height="30px" />
              <Row className="px-2 px-md-5">
                <Col md={12} className="py-2">
                  <BackButton />
                </Col>
              </Row>
              <Row className="px-2 px-md-5">
                <Col md={12}>
                  <Row>
                    <Col xs={12} md={8}>
                      <div className="d-flex align-items-start py-3">
                        <img src={user_icon} width={48} className="me-3 mt-1" alt="user icon" />
                        <div>
                          <h3 className="text-start m-0">{t('kyc.upload_other_id')}</h3>
                          <p className="fw-normal text-secondary m-0 mt-1">{t('kyc.confirm_secure')}</p>
                        </div>
                      </div>
                      <Form noValidate onSubmit={handleSubmit(submitForm)}>
                        <Row className="px-1 px-md-5">
                          <Col xs={12} md={11} className="rounded-3">
                            <Row className="justify-content-center">
                              <Col xs={12} md={5} className="ps-0">
                                <p className={`fw-bold small mt-3 m-0 ${!srcModal1 ? "py-2" : ""}`}>
                                  {t('kyc.front_other_id')}
                                </p>
                                <div
                                  onClick={() => setShowModal1(true)}
                                  className="text-center position-relative d-flex flex-column justify-content-center align-items-center"
                                  style={{
                                    border: `2px dashed ${validated && !srcModal1 ? "#dc3545" : "#C9DAF8"}`,
                                    borderRadius: "12px",
                                    height: "140px",
                                    background: theme === "dark" ? "#1a1a1a" : "#EDF7F3",
                                    cursor: "pointer",
                                    transition: "all 0.2s ease",
                                  }}
                                >
                                  {srcModal1 ? (
                                    <>
                                      <img
                                        src={red_cross_icon}
                                        onClick={(e) => { e.stopPropagation(); handleModal1CrossIconClick(); }}
                                        style={{ position: "absolute", top: "6px", right: "6px", width: "20px", cursor: "pointer", zIndex: 2 }}
                                        alt="Remove icon"
                                      />
                                      <img src={srcModal1} alt="Front Document" className="img-fluid rounded-3 object-fit-cover w-100 h-100" />
                                    </>
                                  ) : (
                                    <>
                                      <i className="fa-solid fa-camera" style={{ fontSize: '32px', color: '#00D084' }} />
                                      <p className="fw-normal small mt-2 mb-0 text-secondary">{t('camera.take_photo')}</p>
                                    </>
                                  )}
                                </div>
                                {validated && !srcModal1 && (
                                  <div className="text-danger small mt-1 fw-bold">
                                    {t('kyc.front_side_missing')}
                                  </div>
                                )}

                                <p className={`fw-bold small mt-3 m-0 ${!srcModal2 ? "py-2" : ""}`}>
                                  {t('kyc.back_other_id')}
                                </p>
                                <div
                                  onClick={() => setShowModal2(true)}
                                  className="text-center position-relative d-flex flex-column justify-content-center align-items-center"
                                  style={{
                                    border: "2px dashed #C9DAF8",
                                    borderRadius: "12px",
                                    height: "140px",
                                    background: theme === "dark" ? "#1a1a1a" : "#EDF7F3",
                                    cursor: "pointer",
                                    transition: "all 0.2s ease",
                                  }}
                                >
                                  {srcModal2 ? (
                                    <>
                                      <img
                                        src={red_cross_icon}
                                        onClick={(e) => { e.stopPropagation(); handleModal2CrossIconClick(); }}
                                        style={{ position: "absolute", top: "6px", right: "6px", width: "20px", cursor: "pointer", zIndex: 2 }}
                                        alt="Remove icon"
                                      />
                                      <img src={srcModal2} alt="Back Document" className="img-fluid rounded-3 object-fit-cover w-100 h-100" />
                                    </>
                                  ) : (
                                    <>
                                      <i className="fa-solid fa-camera" style={{ fontSize: '32px', color: '#00D084' }} />
                                      <p className="fw-normal small mt-2 mb-0 text-secondary">{t('camera.take_photo')}</p>
                                    </>
                                  )}
                                </div>

                                <div className="mt-3 d-none d-md-block">
                                  <p className="fw-bold ms-2 mb-1">{t('kyc.qr_code')}</p>
                                  <Row className={`ms-2 justify-content-center rounded-3 ${theme === "light" && "bg-sky"} mt-3`}>
                                    <div style={{ width: 256, margin: "20px auto 0" }}>
                                      <QRCode value={`${BaseURL}/kyc/personal/${userId}/${kycToken}`} size={256} style={{ width: "100%", height: "auto" }} />
                                    </div>
                                    <p className="fw-bold text-center mt-2">{t('kyc.qr_scan_title')}</p>
                                    <p className="fw-normal text-secondary small text-center mb-5">{t('kyc.qr_scan_desc')}</p>
                                  </Row>
                                </div>
                              </Col>

                              <Col md={6} className="mt-4 d-none d-md-block">
                                <Row className="justify-content-center rounded-3 mt-3 ms-2">
                                  <div className="text-center">
                                    <img
                                      className="mt-3 ms-2 py-3 text-center"
                                      src={identity_card_banner}
                                      width={153}
                                      height={125}
                                      alt="Identity card banner"
                                    />
                                  </div>
                                  <Row className="justify-content-center rounded-2 px-4">
                                    <p className="fw-bold text-secondary small">
                                      {t('kyc.doc_standards_title')}
                                      <ul className="list-group border-0 bg-transparent fw-normal">
                                        <li className="list-group-item border-0 bg-transparent text-secondary p-0">{t('kyc.doc_clear')}</li>
                                        <li className="list-group-item border-0 bg-transparent text-secondary p-0">{t('kyc.doc_not_reflective')}</li>
                                        <li className="list-group-item border-0 bg-transparent text-secondary p-0">{t('kyc.doc_no_edit')}</li>
                                        <li className="list-group-item border-0 bg-transparent text-secondary p-0">{t('kyc.doc_solid_bg')}</li>
                                      </ul>
                                    </p>
                                  </Row>
                                </Row>
                              </Col>

                              <Col md={12} className="d-flex justify-content-end mt-4">
                                <Button className="btn btn-primary rounded-5" onClick={saveExit}>
                                  {t('common.save')}
                                </Button>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </Form>
                    </Col>

                    <Col md={4} className={`py-2 ps-3 d-none d-md-block ${theme === "light" && "bg-white"} rounded-3`}>
                      <p className="fw-bold text-secondary">{t('kyc.other_id_types')}</p>
                      <div className="text-secondary pb-1">
                        <i className="fa-solid fa-check custom-icon-color"></i>&nbsp; {t('kyc.other_id_birth')} &nbsp;&nbsp;
                        <i className="fa-solid fa-check custom-icon-color"></i>&nbsp; {t('kyc.other_id_residence')}
                      </div>
                      <div className="text-secondary pb-1">
                        <i className="fa-solid fa-check custom-icon-color"></i>&nbsp; {t('kyc.other_id_marriage')} &nbsp;&nbsp;
                        <i className="fa-solid fa-check custom-icon-color"></i>&nbsp; {t('kyc.other_id_divorce')}
                      </div>
                      <div className="text-secondary pb-1">
                        <i className="fa-solid fa-check custom-icon-color"></i>&nbsp; {t('kyc.other_id_citizenship')} &nbsp;&nbsp;
                        <i className="fa-solid fa-check custom-icon-color"></i>&nbsp; {t('kyc.other_id_credit_card')}
                      </div>
                      <div className="text-secondary pb-1">
                        <i className="fa-solid fa-check custom-icon-color"></i>&nbsp; {t('kyc.other_id_bank')}
                      </div>
                      <div className="text-secondary pb-1">
                        <i className="fa-solid fa-check custom-icon-color"></i>&nbsp; {t('kyc.other_id_investment')}
                      </div>
                      <div className="text-secondary pb-1">
                        <i className="fa-solid fa-check custom-icon-color"></i>&nbsp; {t('kyc.other_id_insurance')}
                      </div>
                      <div className="text-secondary pb-1">
                        <i className="fa-solid fa-check custom-icon-color"></i>&nbsp; {t('kyc.other_id_photo_id')}
                      </div>
                      <div className="text-secondary pb-1">
                        <i className="fa-solid fa-check custom-icon-color"></i>&nbsp; {t('kyc.other_id_utility')}
                      </div>
                      <div className="text-secondary pb-1">
                        <i className="fa-solid fa-check custom-icon-color"></i>&nbsp; {t('kyc.other_id_visa')}
                      </div>
                      <div className="text-secondary pb-1">
                        <i className="fa-solid fa-check custom-icon-color"></i>&nbsp; {t('kyc.other_id_credit_file')}
                      </div>
                      <div className="text-secondary pb-1">
                        <i className="fa-solid fa-check custom-icon-color"></i>&nbsp; {t('kyc.other_id_student')}
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

const form = reduxForm<{}, Props, FormData>({
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  form: "wizard",
  enableReinitialize: true,
})(UploadOtherDocument);

export default connect(null)(form);
